import * as React from "react";

import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MessageIcon from '@mui/icons-material/Message';
import PaymentsIcon from '@mui/icons-material/Payments';
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";

const iconStyle = { width: "20px", height: "20px", verticalAlign: "middle"};
export const OrderHistoryTypeEnumIcons = [
  {
    id: "notice",
    name: "Notice",
    icon: <MessageIcon color="primary" sx={iconStyle} />,
  },
  {
    id: "payment",
    name: "Payment",
    icon: <PaymentsIcon color="primary" sx={iconStyle} />,
  },
  {
    id: "shipping",
    name: "Shipping",
    icon: <LocalShippingOutlinedIcon color="primary" sx={iconStyle} />,
  },
  {
    id: "customer",
    name: "Customer",
    icon: <AccountCircleIcon color="primary" sx={iconStyle} />,
  }
];